import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import BasePage from '../../baseClasses/BasePage';
import MobileHeader from '../../components/MobileHeader';
import UserSettings from '../../components/UserSettings';
import '../MobileWrapper.scss';
import mobileBridge from '../../helpers/MobileBridge';

export class UserSettingsWrapper extends BasePage {

  componentDidMount() {
    mobileBridge.initialize(this.props.history);
  }

  handleNavigateBack() {
    this.props.history.goBack();
  }

  render() {

    return (
      <div className='mobile-wrapper'>
        <MobileHeader
          headerTitle={'Settings'}
          handleClear={this.handleClear}
          navigateBack={this.handleNavigateBack}
        />
        <div className="content-wrapper">
          <UserSettings
            currentUser={this.props.currentUser}
            isMobile={mobileBridge.isMobile}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    currentUser: state.new_users.currentUser,
  };
};

export default withRouter(connect(mapStateToProps)(UserSettingsWrapper));



// WEBPACK FOOTER //
// ./src/mobileWrappers/UserSettingsWrapper/index.js